@import 'tailwindcss';

label:has(.choice-input__native[type='checkbox']:disabled) {
    @apply text-gray-400 line-through;
}

.choice-input {
    position: relative;
    display: inline-grid;
    width: 1.125rem;
    height: 1.125rem;
    flex: 0 0 auto;
    place-items: center;
    vertical-align: middle;
}

.choice-input__native {
    position: absolute;
    inset: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    opacity: 0;
}

.choice-input__indicator {
    box-sizing: border-box;
    display: grid;
    width: 100%;
    height: 100%;
    place-items: center;
    border: 1px solid var(--color-theme-outline);
    background-color: rgb(from var(--color-theme-950) r g b / 0.7);
    color: var(--color-theme-primary);
    transition:
        background-color 150ms ease,
        border-color 150ms ease,
        box-shadow 150ms ease;
}

.choice-input__indicator--checkbox {
    .round & {
        border-radius: 0.3125rem;
    }
}

.choice-input__indicator--radio {
    border-radius: 9999px;
}

.choice-input__check,
.choice-input__dot {
    opacity: 0;
    transform: scale(0.7);
    transition:
        opacity 150ms ease,
        transform 150ms ease;
}

.choice-input__check {
    width: 0.35rem;
    height: 0.6rem;
    margin-bottom: 0.075rem;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg) scale(0.7);
}

.choice-input__dot {
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 9999px;
    background-color: currentColor;
}

.choice-input:hover .choice-input__indicator {
    border-color: var(--color-theme-300);
}

.choice-input__native:checked + .choice-input__indicator {
    border-color: var(--color-theme-primary);
    background-color: rgb(from var(--color-theme-primary) r g b / 0.15);
}

.choice-input__native:checked + .choice-input__indicator .choice-input__check {
    opacity: 1;
    transform: rotate(45deg) scale(1);
}

.choice-input__native:checked + .choice-input__indicator .choice-input__dot {
    opacity: 1;
    transform: scale(1);
}

.choice-input__native:focus-visible + .choice-input__indicator {
    border-color: var(--color-theme-primary);
    box-shadow: 0 0 0 2px rgb(from var(--color-theme-primary) r g b / 0.2);
}

.choice-input__native:disabled {
    cursor: not-allowed;
}

.choice-input__native:disabled + .choice-input__indicator {
    opacity: 0.5;
}

.choice-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 1.75rem;
    padding: 0.25rem 0.375rem;
    border: 1px solid transparent;

    .round & {
        border-radius: 0.5rem;
    }

    cursor: pointer;
    user-select: none;
    transition:
        background-color 150ms ease,
        border-color 150ms ease;
}

.choice-row:hover {
    background-color: rgb(from var(--color-theme-950) r g b / 0.35);
}

.choice-row:has(.choice-input__native:checked) {
    border-color: rgb(from var(--color-theme-primary) r g b / 0.4);
    background-color: rgb(from var(--color-theme-primary) r g b / 0.1);
}
